export default __webpack_public_path__ + "static/media/markerBlue.10892d77.svg";